export default __webpack_public_path__ + "static/media/Optifo_Full_Logo.5464ace6.svg";